<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
         
        </section>
  
            <!-- Main content -->
            <section class="content">
                <div class="box">
                
                    <div class="box-body" style="min-height:400px;">
                        <h3><strong>Accident Information</strong></h3>
                        <hr>
                        <div class="account-box">
                        <form role="form">

                        <div class="form-group"> 
                        
                                <label for="inputName">Accident Name: </label>
                                <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">

                                  {{accidentName}}
                                </div>
                                </div>
                                <br>
                        
                        <div class="form-group"> 
                        
                                <label for="inputName">Accident Type: </label>
                                <br>
                                 <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">

                                  {{accidentLabel}}
                                </div>
                        
                    </div>

                        <div class="form-group"> 
                                <label for="inputPassword">Accident Location: </label>
                                  
                                 <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">
{{accidentLocation}}  
                                 </div>
                               
                    </div>
                                        <hr>
 <div class="form-group"> 
                        
                                <label for="example-datepicker">Date of Accident: </label>
     <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">
{{dateValue}}
     </div>
                           <br>
    <br>
     <div>
                           <label for="example-timepicker">Time of accident: </label>

     <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">
{{timeValue}}</div>
    <br>
                    </div>
 </div>
                                        <hr>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Additional Accident Information: </label>
                                 <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">
{{additionalInfoTextArea}} </div>
                        
                    </div>
                                        <hr>

                        <div class="form-group"> 
                        
              
                    <h4>Make</h4>
                       <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">
{{makeValue}}
                       </div>
                        
                      <h4>Model</h4>
                         <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">
{{modelValue}}
                         </div>
                                               <h4>Year</h4>

                         <div id="inputName"    style="border:none;margin-top: 10px;
    background: #e6e2e2;">
{{yearValue}}
                         </div>
                    </div>
<hr>
               <div class="form-group"> 
                        <h4 for="inputPassword"><strong>Services Needed </strong></h4>
                        <hr>
                        <div style="border:none;margin-top: 10px;
    background: #e6e2e2;" v-if="this.servicesNeededCheckList.length > 0">
                                <p v-for="service in this.servicesNeededCheckList">
                                    <span style="vertical-align: top;">{{service}} </span>
                                </p>
                        </div>
      </div>
                      <hr>
                    <div class="form-group"> 
                        
                                <label for="inputPassword">Vehicle Speed: </label>
    <br>
                    <div class="block"> 
                         <div style="border:none;margin-top: 10px;
    background: #e6e2e2;">{{vehicleSpeedValue}} MPH</div>
                    </div>
                    <hr>
<br> 
                    <div class="box">
                    <div class="box-header with-border">
                        <h3 class="box-title">Files Uploaded</h3>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                    <div  class="box-body">
                        <el-table
                        id="fileList"
                        empty-text="No files uploaded."
                        :data="fileList"
                        style="width: 100%">
                        
                       
               
                        <el-table-column
                          label="File Name"
                          >
                         <template slot-scope="scope">
    <span class="bold"><i class="dripicons-document-new"></i>&nbsp&nbsp{{scope.row.fileName}}</span>
                </template>
                        </el-table-column>
                         
                         <el-table-column
                          label="Date Uploaded"
                         >
                         <template slot-scope="scope">
                         {{scope.row.dateUploaded}}
                         </template>
                        </el-table-column>
                       <el-table-column
                          label="Options"
                          >
                          <template scope="props">
                            <a>
                         <i 
  @click.prevent="downloadFile(props.row.filePath, props.row.fileName, props.row.contentType)" class="material-icons">file_download</i>
                                          </a>       
                         </template>
                        </el-table-column>
                      </el-table>
                    </div>
                </div>
                    </div>

                    
                        </form>
                        </div>
                                        <hr>

            
                    <br>
                    <br>
                    
                    </div>
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script src = "https://cdnjs.cloudflare.com/ajax/libs/vue/2.6.11/vue.min.js"></script>
<script>
const storage = require('../services/Storage/storage')
import Buttons from "./modules/ui/Buttons.vue";
import utilityFunctions from '../common/utilityFunctions'
const cliStorage = require("../services/libraries/clientStoragelib");
const cliStorNames = cliStorage.clientStorageNames;
var to = require("await-to-js").default;
const db = require("../services/database/database");
  const commonDB = require('../services/database/common')

const Auth = require("../services/Authentication/auth");
const cliStoreOps = require("../common/clientStorageOperations");
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TimePicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
//import { util } from 'vue/types/umd';
const vehicleMakeModel = require('../store/vehicleMakeModelList.json')
const models = require('../services/database/models')

export default {
  components: { Buttons, DatePicker, TimePicker },
  name: "viewAccident",
  props: ["user"],
  watch: {
    input: function () {
      if (
        isLocalStorage() /* function to detect if localstorage is supported*/
      ) {
        localStorage.setItem("storedData", this.input);
      }
    },
  },
   async beforeMount(){
        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        if (!userToken){
         
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
        }
        this.userToken = userToken
        const jwt_decode = require('jwt-decode');
      const decoded_header = jwt_decode(this.userToken)
      this.userAccountId = decoded_header.user_id
        const accidentId = this.$route.params.accidentId
        if(!accidentId)
        {
          this.$router.push('/404')
        }
        this.accidentId = accidentId
        console.log("accident ID:", accidentId)
        if (!accidentId){
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()

          console.error("no accident ID")
        }
        console.log("here created")
        let userErr, userRes;
          [userErr, userRes] = await to(Auth.getUser({ UID: userToken }));
          if (userErr) {
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                              this.$router.push('/login')

          } else if (userRes) {
              console.log("userRes",userRes)
              const userId = this.$cookie.get(cliStorNames.USER_ID.name)
              if (!userId)
              {
                //TODO: eventually need to add plan B here, maybe just look up the user and get the ID
                console.warn("No user id found.")
              }
              this.userId = userId
let userDbRes, userDbErr; 
                  [userDbErr, userDbRes]= await to(commonDB.getUserFromDB(this.userToken, this.userAccountId, this.userAccountId))
                  if (userDbErr){
                      console.error(userDbErr)
                      this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                 
                                    let pulledUserId = userDbRes.data.fields.userId.stringValue
                                    //VERY IMPORTANT! ==> Keeps 1 user from accesing another user's profile
                if (pulledUserId !== this.userId){
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
               let dbRes, dbErr; 
                  [dbErr, dbRes]= await to(commonDB.getAccidentFromDB(this.userToken, this.userAccountId, this.accidentId))
                  if (dbErr){
                      console.error(dbErr)
                       this.$confirm("Unable to retrieve Accident Entry. Please try again at a later time.", 'View Accident Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                  try{
                  //should only be one entry
                  
                                      let accident = {};
                                          accident.accidentName = dbRes.data.fields.accidentName.stringValue

              accident.accidentType = dbRes.data.fields.accidentType.stringValue
              accident.accidentTime = dbRes.data.fields.accidentTime.stringValue
              accident.vehicleMake = dbRes.data.fields.vehicleMake.stringValue
              accident.vehicleModel = dbRes.data.fields.vehicleModel.stringValue
              accident.vehicleYear = dbRes.data.fields.vehicleYear.stringValue
              accident.vehicleSpeed = dbRes.data.fields.vehicleSpeed.stringValue
              accident.accidentId = dbRes.data.fields.accidentId.stringValue,
              accident.accidentLocation = dbRes.data.fields.accidentLocation.stringValue
              accident.accidentClaimStatus = dbRes.data.fields.accidentClaimStatus.stringValue
              accident.additionalAccidentInformation = dbRes.data.fields.additionalAccidentInformation.stringValue
              console.log(new Date(parseInt(dbRes.data.fields.timeSubmitted.stringValue)))
               accident.timeSubmitted = new Date(parseInt(dbRes.data.fields.timeSubmitted.stringValue)).toString() 
               accident.accidentDate = new Date(dbRes.data.fields.accidentDate.stringValue).toString()
               accident.filesUploaded = []
               //NOTE: firebase returns undefined for empty array fields in firestore DB
               if ( dbRes.data.fields.filesUploaded.arrayValue.values)
               {
              accident.filesUploaded =  dbRes.data.fields.filesUploaded.arrayValue.values

               }
               let accidentDate = dbRes.data.fields.accidentDate.stringValue 
              accident.accidentDate = accidentDate
              if(accidentDate !== ''){
              accident.accidentDate = new Date(accidentDate).toString()
               if(accident.accidentTime){
                console.log(accident.accidentTime)
               accident.accidentDate = accident.accidentDate.replace(/\d\d:\d\d:\d\d[\s\S]*$/, accident.accidentTime)
                console.log(accident.accidentDate)
              }
              }
               
                accident.accidentServicesRequested = []
               if ( dbRes.data.fields.accidentServicesRequested.arrayValue.values)
               {
              accident.accidentServicesRequested = dbRes.data.fields.accidentServicesRequested.arrayValue.values

               }
              console.log("services",  accident.accidentServicesRequested)
              this.accidentList.push(accident)
        
                  

                  this.accidentName = this.accidentList[0].accidentName
                  this.accidentDate = this.accidentList[0].accidentDate
                  this.accidentTypeSelect = this.accidentList[0].accidentType
                  // let filteredAccidentType = this.options.filter(e => e.value === this.accidentTypeSelect)[0]
                  // if (filteredAccidentType.length > 0){
                  //     this.accidentLabel = filteredAccidentType.label
                  // }
                   
                  this.accidentLocation = this.accidentList[0].accidentLocation
                  this.vehicleSpeedValue = parseInt(this.accidentList[0].vehicleSpeed)
                  this.makeValue = this.accidentList[0].vehicleMake
                  this.modelValue = this.accidentList[0].vehicleModel
                  this.yearValue = this.accidentList[0].vehicleYear
                  this.additionalInfoTextArea = this.accidentList[0].additionalAccidentInformation
                  this.dateValue = this.accidentList[0].accidentDate
                  this.timeValue = this.accidentList[0].accidentTime
                  this.filesUploaded = this.accidentList[0].filesUploaded

                  for(var services of this.accidentList[0].accidentServicesRequested){
                  this.servicesNeededCheckList.push(services.stringValue)  
                  
                  }
                  console.log("filesUploaded", this.accidentList[0].filesUploaded)
                  let parsedFilesUploadedArr = utilityFunctions.parseArrayOfObjectsFirestoreDB(this.filesUploaded)
                                    console.log("parsedfilesUploaded", parsedFilesUploadedArr)

                  for(let fileObj of parsedFilesUploadedArr){
                    const fileName = utilityFunctions.getFileNameFromStoragePath(fileObj.filePath)
                    console.log("name", fileName)
                    //unsafe code
                    let standardDateUploadedFormat = new Date(parseInt(fileObj.dateUploaded))
                                        console.log("DU", standardDateUploadedFormat)

                    this.fileList.push({fileName, filePath: fileObj.filePath, dateUploaded:standardDateUploadedFormat})
                  }
                  this.parsedFilesUploaded = parsedFilesUploadedArr

              
          
                  }
                  catch(err){
                    console.error(err)
                     this.$confirm("Unable to retrieve Accident Entry. Please try again at a later time.", 'View Accident Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                  

      }
      
      },
  
  //need to clear fro local str maybe
  created() {
            const accidentId = this.$cookie.get(cliStorNames.ACCIDENT_ID.name)
            this.accidentId = accidentId 
    //       if (window.localStorage) {
    //                 if (!localStorage.getItem(cliStorNames.FIRST_NAME.name)){
    //                 localStorage.setItem(cliStorNames.FIRST_NAME.name, this.$route.params.user.firstName)
    //                 }
    // {
    //                                 if (!localStorage.getItem(cliStorNames.LAST_NAME.name))
    //                 localStorage.setItem(cliStorNames.LAST_NAME.name, this.$route.params.user.lastName)
    // }
    //                 if (!localStorage.getItem(cliStorNames.EMAIL.name)){
    //                 localStorage.setItem(cliStorNames.EMAIL.name, this.$route.params.user.email)
    //                 }
    //                                 if (!localStorage.getItem(cliStorNames.PHONE.name)){
    //                 localStorage.setItem(cliStorNames.PHONE.name, this.$route.params.user.phone)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.CITY.name)){
    //                                                     localStorage.setItem(cliStorNames.CITY.name, this.$route.params.user.city)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.STATE.name)){
    //                                                     localStorage.setItem(cliStorNames.STATE.name, this.$route.params.user.state)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.ZIPCODE.name)){
    //                 localStorage.setItem(cliStorNames.ZIPCODE.name, this.$route.params.user.zipcode)}
    //       }

  },
  beforeDestroy() {
    //   if (window.localStorage) {
    //     localStorage.removeItem(cliStorNames.FIRST_NAME.name)
    //   localStorage.removeItem(cliStorNames.LAST_NAME.name)
    //   localStorage.removeItem(cliStorNames.CITY.name)
    //    localStorage.removeItem(cliStorNames.EMAIL.name)
    //  localStorage.removeItem(cliStorNames.PHONE.name)
    //   localStorage.removeItem(cliStorNames.STATE.name)
    //     localStorage.removeItem(cliStorNames.ZIPCODE.name)
    //  localStorage.removeItem(cliStorNames.USER_ID.name)
    //   }
  },

  data() {
    return {
      action: "http://localhost:8080/?#/accidentInformationPage",
      active: true,
      userAccountId: "",
      parsedFilesUploaded: [],
      fileList: [],
      modelOptions: [],
              servicesNeededCheckList: [],
      accidentList: [],
      yearOptions: [
        1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991,
        1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003,
        2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
        2016, 2017, 2018, 2019, 2020, 2021, 2022,
      ],
      makeOptions: vehicleMakeModel,
      vehicleSpeedValue: 0,
      dateValue: "",
      files: "",
      accidentLabel: "",
      dialogImageUrl: "",
      dialogVisible: false,
      inputFile: {},
      inputFilter: {},
      timeValue: "",
      accidentName: "",
      fileList: [],
      filesUploaded:[],
      servicesNeededCheckList: [],
      fileNameSelected: "",
      accidentId: "",
      userToken:"",
      options: [
        {
          value: "rearEnd",
          label: "Rear-End",
        },
        {
          value: "headOn",
          label: "Head-On",
        },
        {
          label: "Fender-Bender",
          value: "fenderBender",
        },
        {
          value: "sideImpactCollision",
          label: "Side-impact collision",
        },
        {
          value: "singleCar",
          label: "Single Car Accident(No other driver involved)",
        },
      ],
      accidentTypeSelect: "",
      accidentTimeRadio: "",
      accidentLocation: "",
      additionalInfoTextArea: "",
      makeValue: "",
      makeObj: {}, //obj to extract models and name
      modelValue: "",
      yearValue: "",
      accidentObj: {},
      accidentId: '',
      upload: {
        active: false,
      },
    };
  },
  methods: {
     downloadFile: async function(path, fileName, contentType){
var params = {
                    filePath: path,
                    userToken: this.userToken
                  };
                  let downloadRes, downloadErr;
                  
                  [downloadErr, downloadRes] = await to(storage.download(params))
                  if(downloadErr){
                    console.error(downloadErr.data)
                  }
                  console.log(downloadRes)
                  //unsafe code
                  const blob = new File([utilityFunctions._base64ToArrayBuffer(downloadRes.data[0])], {type: contentType})
                 
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        URL.revokeObjectURL(link.href)
    },


    updateModelDropdown(){
          this.modelValue = ''
          this.yearValue=  ''
          this.modelOptions =  this.makeOptions.filter(e => e.brand === this.makeValue)[0].models;//unsafe
          console.log("changed", this.modelOptions)
      },
       
    

  
    updateClientStorage: function(accidentName, accidentDate, accidentType, vehicleMake, vehicleModel, vehicleYear, additionalInfo, servicesNeeded){
        this.accidentName = localStorage.setItem(cliStorNames.ACCIDENT_NAME.name, accidentName)
     this.accidentType = localStorage.setItem(cliStorNames.ACCIDENT_TYPE.name, accidentType)
      this.accidentDate = localStorage.setItem(cliStorNames.ACCIDENT_DATE.name, accidentDate)
       this.YearValue = localStorage.setItem(cliStorNames.VEHICLE_YEAR.name, vehicleYear)
     this.modelValue = localStorage.setItem(cliStorNames.VEHICLE_MODEL.name, vehicleModel)
      this.makeValue = localStorage.setItem(cliStorNames.VEHICLE_MAKE.name, vehicleMake)
       this.additionalInfo = localStorage.setItem(cliStorNames.ADDITIONAL_TEXT.name, additionalInfo)
        this.servicesNeeded = localStorage.setItem(cliStorNames.SERVICES_REQUESTED.name, servicesNeeded)

    },
   
  },
};
</script>



// WEBPACK FOOTER //
// ViewAccident.vue?5ea3a984